import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useStoreItem, StoreItem } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<StoreItem>
    useData={useStoreItem}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
